import React from "react";
import { useQuery } from "@tanstack/react-query";
import { PageHeader } from "../../layout/AppLayout";
import { ErpTable } from "../../components/erp";
import { errorText } from "../../api/client";
import { salesApi, BuyerRow, ConsigneeRow, BankRow } from "./api";

/** Port of ApiV2/Exports/Controller/{BuyerListDetailsController,ConsigneeListDetailsController,
 * BanksListDetailsController}.php - read-only masters (no INSERT/UPDATE in any of these controllers
 * in source; add/edit forms - AddBuyer.php/AddConsigneeDetails.php - are separate, larger write
 * flows deferred, see MIGRATION.md § Sales remaining work). */
export function BuyersMaster() {
  const list = useQuery({ queryKey: ["sales", "buyers"], queryFn: salesApi.buyers });
  return (
    <>
      <PageHeader title="Buyers" location="Sales" />
      <div className="card" data-testid="sales-buyers-page"><div className="card-body">
        <ErpTable<BuyerRow> testId="sales-buyers-table" loading={list.isLoading} error={list.isError ? errorText(list.error) : null}
          rows={list.data?.Data || []} columns={[
            { key: "SNO", title: "#" }, { key: "BuyerName", title: "Buyer Name" }, { key: "BuyerAddress", title: "Address" },
            { key: "Country", title: "Country" }, { key: "BuyerEmailAddress", title: "Email" },
          ]} />
      </div></div>
    </>
  );
}

export function ConsigneesMaster() {
  const list = useQuery({ queryKey: ["sales", "consignees"], queryFn: salesApi.consignees });
  return (
    <>
      <PageHeader title="Consignees" location="Sales" />
      <div className="card" data-testid="sales-consignees-page"><div className="card-body">
        <ErpTable<ConsigneeRow> testId="sales-consignees-table" loading={list.isLoading} error={list.isError ? errorText(list.error) : null}
          rows={list.data?.Data || []} columns={[
            { key: "SNO", title: "#" }, { key: "ConsigneeName", title: "Consignee Name" }, { key: "ConsigneeAddress", title: "Address" },
            { key: "Country", title: "Country" }, { key: "EmailAddress", title: "Email" },
          ]} />
      </div></div>
    </>
  );
}

export function BanksMaster() {
  const list = useQuery({ queryKey: ["sales", "banks"], queryFn: salesApi.banks });
  return (
    <>
      <PageHeader title="Banks" location="Sales" />
      <div className="card" data-testid="sales-banks-page"><div className="card-body">
        <ErpTable<BankRow> testId="sales-banks-table" loading={list.isLoading} error={list.isError ? errorText(list.error) : null}
          rows={list.data?.Data || []} columns={[
            { key: "SNO", title: "#" }, { key: "AccountName", title: "Account Name" }, { key: "BankName", title: "Bank" },
            { key: "AccountNumber", title: "Account No" }, { key: "SwiftCode", title: "Swift" }, { key: "RoutingThrough", title: "Routing Through" },
          ]} />
      </div></div>
    </>
  );
}
